import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Footer = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <section role='Footer'>
        <Container>
          <Row className='justify-content-between'>
            <Col md={4}>
              <section className='foooterInfo'>
                <header className='Links-title'>
                  <h2>About Us</h2>
                </header>
                <p>
                  We are a concerned group of citizens and advocates within our
                  local government area who are committed to promoting
                  transparency, accountability, and genuine community
                  participation in the decision-making processes that affect our
                  community's well-being.
                </p>
              </section>
            </Col>
            <Col md={2}>
              <section className='Links'>
                <header className='Links-title'>
                  <h2>Quick links</h2>
                </header>

                <ul className='Links-box'>
                  <li className='Links-box-item'>
                    {' '}
                    <Link to='/news'>
                      {' '}
                      <i className='fa fa-chevron-right me-2'></i> News
                    </Link>
                  </li>
                  {/* <li className='Links-box-item'>
                    {' '}
                    <Link to='/products'>
                      {' '}
                      <i className='fa fa-chevron-right me-2'></i>About Us
                    </Link>
                  </li> */}
                  <li className='Links-box-item'>
                    {' '}
                    <a href='/gallery'>
                      {' '}
                      <i className='fa fa-chevron-right me-2'></i>Gallery
                    </a>
                  </li>
                  <li className='Links-box-item'>
                    {' '}
                    <Link to='/contact-us'>
                      {' '}
                      <i className='fa fa-chevron-right me-2'></i>
                      Contact
                    </Link>
                  </li>
                </ul>
              </section>
              <section className='socialMedia'>
                <header className='socialMedia-title'>
                  <h2>Find Us On</h2>
                </header>

                <section className='socialWrapper'>
                  <a
                    href='https://www.facebook.com/communityvoicecampbelltown?mibextid=LQQJ4d'
                    target='_blank'
                    rel='noreferrer noopener'
                  >
                    <div className='socialWrapper-icons'>
                      <i className='fa fa-facebook-f'></i>
                    </div>
                  </a>
                </section>
              </section>
            </Col>

            <Col md={4}>
              <section className='contact'>
                <header className='contact-title'>
                  <h2>Reach Us</h2>
                </header>

                <ul className='contact-box'>
                  <li className='contact-box-item'>
                    <div className='iconHolder'>
                      <i className='fa fa-map-marker'></i>
                    </div>
                    <div className='addHolder'>
                      <div className='addHolder-key'>
                        <strong>Mailing Address</strong>{' '}
                      </div>
                      <div className='addHolder-value '>
                        43 Borthwick St Minto -2566
                      </div>
                    </div>
                  </li>
                  <li className='contact-box-item'>
                    <div className='iconHolder'>
                      <i className='fa fa-phone'></i>
                    </div>
                    <div className='addHolder'>
                      <div className='addHolder-key'>
                        <strong>Phone</strong>{' '}
                      </div>
                      <div className='addHolder-value '> 0412458815</div>
                    </div>
                  </li>

                  <li className='contact-box-item'>
                    <div className='iconHolder'>
                      <i className='fa fa-envelope'></i>
                    </div>
                    <div className='addHolder'>
                      <div className='addHolder-key'>
                        <strong>Email</strong>{' '}
                      </div>
                      <div className='addHolder-value '>
                        <a href='mailto:info@communityvoice.org.au'>
                          <span style={{ color: 'white' }}>
                            info@communityvoice.org.au
                          </span>
                        </a>
                      </div>
                    </div>
                  </li>
                </ul>
              </section>
            </Col>
          </Row>

          <hr />
          <section className='copyright'>
            Community Voice &copy; {new Date().getFullYear()} All Rights
            Reserved
          </section>
        </Container>
      </section>
    </>
  );
};

export default Footer;
